























import { Component, mixins } from 'nuxt-property-decorator';
import WarRoomJobApplicationMixin from '@/components/partials/war-room/WarRoomJobApplicationBanner/WarRoomJobApplicationMixin';
import Footer from '@/components/global/Footer/Footer.vue';
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

@Component<DefaultLayout>({
  components: {
    HeaderMenuNotifications: () =>
      import('@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotifications.vue'),
    // We include footer component without async, otherwise styles of footer will be loaded in external chunk,
    // but in prune mode (for crawler) it wouldn't and footer won't have styles at all
    Footer,
  },
})
export default class DefaultLayout extends mixins(defaultLayoutMixin, WarRoomJobApplicationMixin) {}
